import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthAdminGuard } from './core/auth/guard/auth-admin.guard';
import { AuthGuard } from './core/auth/guard/auth.guard';

export const routes: Routes = [


  // AUTHS
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'auth-admin',
    loadChildren: () =>
      import('./modules/auth-admin/auth-admin.module').then(
        (m) => m.AuthAdminModule
      ),
  },

  // ACCESS
  {
    path: 'user',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./_metronic/layout/layout.module').then((m) => m.LayoutModule),
  },
  {
    path: 'admin',
    canActivate: [AuthAdminGuard],
    loadChildren: () =>
      import('./_metronic/layout-admin/layout-admin.module').then(
        (m) => m.LayoutAdminModule
      ),
  },

  // OTHERS
  {
    path: '',
    redirectTo: 'user/access',
    pathMatch: 'full',
  },
  {
    path: 'error',
    loadChildren: () =>
      import('./modules/errors/errors.module').then((m) => m.ErrorsModule),
  },
  { path: '**', redirectTo: 'error/404' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
